import React, { useState, useEffect } from 'react';
import './Challenge.css';
import { CSVLink } from 'react-csv';
import { useUser } from '../context/UserContext';
import Select from 'react-select';
import { FiChevronDown,FiRefreshCw  } from 'react-icons/fi';

const SalesRegister = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const token = localStorage.getItem('auth-token');
  const [selectedAcademy, setSelectedAcademy] = useState('');
  const getFormattedDate = (date) => date.toISOString().split('T')[0];
  const today = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);
  const [fromDate, setFromDate] = useState(getFormattedDate(tenDaysAgo));
  const [toDate, setToDate] = useState(getFormattedDate(today));
  const [sortConfig, setSortConfig] = useState({
    key: 'purchaseDate',
    direction: 'descending',
    numericColumns: ['totalPlayingHours', 'hoursUsed', 'selfRating'],
    dateColumns: ['purchaseDate', 'joiningDate', 'expiryDate']
  });
  const [SalesRegister, setSalesRegister] = useState([]);
  const [academyList, setAcademyList] = useState([]);
  const { selectedCenter, setSelectedCenter, userData } = useUser();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (selectedCenter) {
      setSelectedAcademy(Number(selectedCenter));
    }
  }, [selectedCenter]);


  const fetchData = async () => {
    setLoading(true);
    setError('');
    try {
      const apiBaseUrl = process.env.REACT_APP_API_REPORTS_PLAYING_SUBSCRIPTION;
      const apiUrl = `${apiBaseUrl}?purchaseDateFrom=${fromDate}&purchaseDateTo=${toDate}`;
  
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      };
  
      const response = await fetch(apiUrl, { method: 'GET', headers });
  
      if (!response.ok) throw new Error('Network response was not ok');
  
      const result = await response.json();
  
      if (result.success && result.data.subscriptions) {
        let academies = result.data.academies
          ? Object.entries(result.data.academies).map(([id, name]) => ({ id: Number(id), name }))
          : [];
  
        if (userData?.userType === 'ACADEMY') {
          academies = academies.filter(academy => userData.academyIds.includes(academy.id));
        }
  
        setAcademyList(academies);
  
        const transformedData = result.data.subscriptions.map((subscription) => ({
          name: subscription?.userName || '-',
          phone: subscription?.userMobile || '-',
          preferredCenterId: subscription?.courtSubscription?.preferredAcademyId || '-',
          preferredCenter: subscription?.academyName || '-',
          purchaseDate: formatDate(subscription?.courtSubscription?.purchaseDate) || '-',
          joiningDate: formatDate(subscription?.courtSubscription?.joiningDate) || '-',
          expiryDate: formatDate(subscription?.courtSubscription?.expiryDate) || '-',
          planType: subscription?.sportsPlanType || '-',
          sportType: subscription?.sportsType || '-',
          preferredSport: subscription?.sportName || '-',
          selfRating: subscription?.selfRating || '-',
          totalPlayingHours: subscription?.courtSubscription?.hoursCredited || '-',
          hoursUsed: Math.max(
            0,
            (subscription?.courtSubscription?.hoursCredited || 0) -
            (subscription?.courtSubscription?.hoursRemaining || 0)
          ),
        }));
        
        setSalesRegister(transformedData);
      } else {
        setError('Failed to load data: ' + result.success_message);
      }
    } catch (error) {
      setError('Error fetching data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchData();
  }, [fromDate, toDate]);
  
  const formatDate = (dateString) => {
    if (!dateString) return "Not Available";

    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };
  const headers = [
    { label: "Name", key: "name" },
    { label: "Phone", key: "phone" },
    { label: "Preferred Center", key: "preferredCenter" },
    { label: "Purchase Date", key: "purchaseDate" },
    { label: "Joining Date", key: "joiningDate" },
    { label: "Expiry Date", key: "expiryDate" },
    { label: "Plan Type", key: "planType" },
    { label: "Sport Type", key: "sportType" },
    { label: "Preferred Sport", key: "preferredSport" },
    { label: "Total Playing Hours", key: "totalPlayingHours" },
    { label: "Hours Used", key: "hoursUsed" },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };
  const sortData = (data) => {
    const { key, direction, numericColumns, dateColumns } = sortConfig;
    if (!key) return data;

    return [...data].sort((a, b) => {
      if (numericColumns.includes(key)) {
        const numA = parseFloat(a[key]) || 0;
        const numB = parseFloat(b[key]) || 0;
        return direction === 'ascending' ? numA - numB : numB - numA;
      }

      if (dateColumns.includes(key)) {
        const dateA = new Date(a[key]).getTime();
        const dateB = new Date(b[key]).getTime();
        return direction === 'ascending' ? dateA - dateB : dateB - dateA;
      }

      const valueA = String(a[key] || '').toLowerCase();
      const valueB = String(b[key] || '').toLowerCase();

      if (valueA < valueB) return direction === 'ascending' ? -1 : 1;
      if (valueA > valueB) return direction === 'ascending' ? 1 : -1;
      return 0;
    });
  };
  const filteredAndSortedSalesRegister = sortData(
    SalesRegister.filter((Sales) => {
      const matchesSearch = Object.values(Sales)
        .join(' ')
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

      const matchesAcademy =
        selectedAcademy === '' ||
        Number(Sales.preferredCenterId) === Number(selectedAcademy);


      const belongsToUserAcademy = userData?.userType !== 'ACADEMY' ||
        userData.academyIds.includes(Number(Sales.preferredCenterId));

      return matchesSearch && matchesAcademy && belongsToUserAcademy;
    })
  );

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ ...sortConfig, key, direction });
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedAcademy, fromDate, toDate]);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredAndSortedSalesRegister.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredAndSortedSalesRegister.length / rowsPerPage);
  const totalEntries = filteredAndSortedSalesRegister.length;

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const getSortingArrow = (column) => {
    if (sortConfig.key === column) {
      return sortConfig.direction === 'ascending' ? '↑' : '↓';
    }
    return '';
  };

  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;
  const academyOptions = academyList
    .filter(academy =>
      userData?.userType === "ACADEMY"
        ? userData.academyIds.includes(Number(academy.id))
        : true
    )
    .map(academy => ({
      value: academy.id,
      label: academy.name
    }));

  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">

        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${selectedAcademy ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={academyOptions}
            value={academyOptions.find(option => option.value === selectedAcademy)}
            onChange={(selectedOption) => setSelectedAcademy(selectedOption?.value || '')}
            placeholder="Select Center"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {selectedAcademy && <label htmlFor="selectedAcademy">Academy</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${fromDate ? "has-value" : ""}`}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          {fromDate && <label htmlFor="fromDate">Start Date</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${toDate ? "has-value" : ""}`}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          {toDate && <label htmlFor="toDate">End Date</label>}
        </div>

      </div>

      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        <CSVLink
          data={filteredAndSortedSalesRegister}
          headers={headers}
          filename="PlayingSubscription.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>
      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchData}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>

      </div>

      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredAndSortedSalesRegister.length === 0 && (
        <div className="error-message">No data available</div>
      )}

      
      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {currentRows.map((Sales, index) => (
              <tr key={index}>
                <td>{Sales.name}</td>
                <td>{Sales.phone}</td>
                <td>{Sales.preferredCenter}</td>
                <td>{Sales.purchaseDate}</td>
                <td>{Sales.joiningDate}</td>
                <td>{Sales.expiryDate}</td>
                <td>{Sales.planType}</td>
                <td>{Sales.sportType}</td>
                <td>{Sales.preferredSport}</td>
                <td>{Sales.totalPlayingHours}</td>
                <td>{Sales.hoursUsed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>

    </div>
  );
};

export default SalesRegister;